import { createOutputTextItem } from '$tablet-app/src/app/chat/ChatItem/functions';
import { AddChatItemFunction } from '$tablet-app/src/app/chat/types';
import { callNumberWithPhoneContact } from '$tablet-app/src/app/contacts/functions';
import { filterContactsByText } from '@akin-home/contacts';
import { listAllContactsForHabitatQuery } from '@akin-home/contacts/frontend';
import { sendBackgroundMessage } from '../../functions';
import { intent_labels } from '../../intent_labels';
import { CallContactCommand } from '../types';

interface Params {
  habitatID: string;
  command: CallContactCommand;
  addItem?: AddChatItemFunction;
}

const handleCallContactCommand = async (params: Params): Promise<void> => {
  const {
    habitatID,
    command: {
      data: {
        name,
        not_found_message,
        no_number_message,
        success_message,
        delay,
      },
    },
    addItem,
  } = params;

  /** No name, abort the command */
  if (!name) return;

  /** Query Contacts. Get all for the habitat.  */
  const contacts = await listAllContactsForHabitatQuery({ habitatID });

  /** Filter the contacts locally */
  const filtered_contacts = filterContactsByText(contacts, name);

  /** Check if a contact was found */
  if (filtered_contacts.length === 0) {
    if (not_found_message) {
      addItem?.(createOutputTextItem(not_found_message));
    }
    /** No matching contact found, abort */
    return;
  }

  /** For now just grab the first contact, later we will display a list if multiple matches */
  const contact = filtered_contacts[0];
  const phoneNumbers = contact.phoneNumbers || [];
  const phone_number = phoneNumbers[0]?.number;

  if (!phone_number || phone_number === '') {
    if (no_number_message) {
      addItem?.(createOutputTextItem(no_number_message));
    }
    return;
  }

  /** Success! */
  if (success_message) {
    addItem?.(createOutputTextItem(success_message));
  }

  /** Call the contact */
  const delay_by_milliseconds = parseCallingDelay(delay);

  if (delay_by_milliseconds) {
    setTimeout(() => {
      callNumberWithPhoneContact({
        name: contact.name || name,
        number: phone_number,
      });
    }, delay_by_milliseconds);
  } else {
    callNumberWithPhoneContact({
      name: contact.name || name,
      number: phone_number,
    });
  }

  sendBackgroundMessage(intent_labels.call_contact, {
    context: {
      contact: { id: contact.id, name: contact.name },
      number: phone_number,
    },
  });

  return;
};

const parseCallingDelay = (delay?: string) => {
  if (!delay) return;

  try {
    return parseInt(delay);
  } catch (e) {
    return;
  }
};

export default handleCallContactCommand;
